import React from 'react';
import classNames from 'classnames';
import useEpisodePlayersContext from "../../../hooks/useEpisodePlayersContext";
import usePlayersContext from "../hooks/usePlayersContext";

const SubscribeButton = () => {
    const { closeAllPopups, showPopupSubscribe, popupSubscribe, episodeIndex } = usePlayersContext();
    const { data } = useEpisodePlayersContext();

    const btnClass = classNames('player-app__btn', 'episode-player-subscribe', {
        'episode-player-active': showPopupSubscribe,
    });
    return (
      (data?.subscribe || data?.episodes[episodeIndex].subscribe) && <button
            onClick={() => {
                closeAllPopups();
                popupSubscribe();
            }}
            className={btnClass}
            aria-label="Subscribe"
        >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.00016 7.68164C4.45681 7.16191 6.83724 9.54309 6.31826 12.9997M1.00016 4.35856C6.29201 3.83883 10.1611 7.70797 9.64141 12.9998M1.00016 1.03474C8.12795 0.51576 13.4843 5.8721 12.9653 12.9999M2.33333 13C1.5971 13 1 12.4029 1 11.6667C1 10.9304 1.5971 10.3333 2.33333 10.3333C3.06956 10.3333 3.66667 10.9304 3.66667 11.6667C3.66667 12.4029 3.06956 13 2.33333 13Z" stroke="#321A51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </button>
    );
};

export default SubscribeButton;
